<template>
    <el-container direction="vertical" class="card contact-card" v-loading="loading">
        <el-row class="card-header">
            <el-col :span="16">
                <div class="page-title bold fnt-lg dark text-left">
                    Карточка контакта
                </div>
            </el-col>
            <el-col :span="8" class="actions">
                <span class="action-title action-edit" @click="edit" v-if="canEdit">
                    Редактировать
                </span>
                <span class="action-title action-close" @click="close">
                    Закрыть
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="7" justify="start" class="card-general card-view">
                <el-row class="mb25">
                    <el-col :span="24" class="bold fnt-mid2">
                        {{ contact.name }}
                    </el-col>
                </el-row>
                <el-row class="mb25 wauto">
                    <el-col :span="5" class="label">
                        <span class="bold">
                            Телефон:
                        </span>
                    </el-col>
                    <el-col :span="19" v-if="contact.contact_phones">
                        <div class="tel-item" v-for="phone in contact.contact_phones" :key="phone.id">
                            {{ masker(phone.phone, '+# (###) ###-##-##', true, tokens) }}
                            <span class="icon-phone pointer pl10" @click="calltoPhone(phone.phone)">
                                <font-awesome-icon icon="phone" class="orange" title="Позвонить" />
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="mb25">
                    <el-col :span="5">
                        <span class="bold">
                            E-mail:
                        </span>
                    </el-col>
                    <el-col :span="19">
                        {{ contact.email }}
                    </el-col>
                </el-row>
                <el-row class="mb25">
                    <el-col :span="5">
                        <span class="bold">
                            День рождения:
                        </span>
                    </el-col>
                    <el-col :span="19">
                        {{ contact.birthday_date }}
                    </el-col>
                </el-row>
                <el-row class="mb25">
                    <el-col :span="5">
                        <span class="bold">
                            Компания:
                        </span>
                    </el-col>
                    <el-col :span="17">
                        {{ contact.company_name }}
                    </el-col>
                    <el-col :span="2" v-if="issetCompany">
                        <div class="cell-icon" @click="goCompany(contact.company.id)">
                        </div>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="16" class="card-comment">
                <span class="bold">
                    Комментарий:
                </span>
                <div v-format-text="contact.comment">
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faPhone } from '@fortawesome/free-solid-svg-icons';
import masker from '@/components/vue-the-mask/src/masker';
import '@/assets/styles/card.scss';

library.add(faCheck, faPhone);

const tokens = {
    '#': { pattern: /\d/ },
    'X': { pattern: /[0-9a-zA-Z]/ },
    'S': { pattern: /[a-zA-Z]/ },
    'A': { pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
    'a': { pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase() },
    '!': { escape: true }
};

export default {
    name: 'ContactsCard',
    props: {
        id: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            loading: true,
            contact: {},
            tokens
        };
    },
    beforeMount() {
        this.$store.dispatch('contacts/getContact', this.id).then(
            response => {
                this.loading = false;
                this.contact = response.data.data;
            },
            error => {
                if (error.response.status !== 422) {
                    console.log(error.response.data.error);
                    this.loading = false;
                    this.$router.push({ name: 'contacts' });
                }
            }
        );
    },
    computed: {
        canEdit() {
            const approvedRoles = this.$store.getters['references/rolesBySectionContacts'];
            if (approvedRoles.indexOf('companies_read') !== -1) {
                approvedRoles.splice(approvedRoles.indexOf('companies_read'), 1);
            }
            const roles = this.$store.state.auth.roles;
            const intersection = Object.keys(roles).filter(x => approvedRoles.includes(x));
            return intersection.length > 0;
        },
        issetCompany() {
            return this.contact.company_id > 0;
        }
    },
    methods: {
        edit() {
            if (this.canEdit) {
                this.$router.push({ name: 'contact-card-edit', params: { id: '' + this.id } });
            }
        },
        close() {
            this.$router.push({ name: 'contacts' });
        },
        goCompany(id) {
            this.$router.push({ name: 'company-card', params: { id: '' + id } });
        },
        calltoPhone(phone) {
            this.loading = true;
            this.$store.dispatch('voip/callToPhone', { phone: phone }).then(
                response => {
                    this.$message({
                        showClose: true,
                        message: 'Начат звонок на номер ' + phone,
                        type: 'success',
                        duration: 3000,
                        customClass: this.alertClass()
                    });
                    this.errors = {};
                },
                error => {
                    console.log('error', error.response.data);
                    this.$message({
                        showClose: true,
                        message: 'Ошибка при звоноке на номер ' + phone,
                        type: 'error',
                        duration: 1500,
                        customClass: this.alertClass()
                    });
                }
            ).finally(() => { this.loading = false; });
        },
        masker
    }
};
</script>
